import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class UploadDevice {
  constructor () {
    instance = instance || this

    this._table = DB.uploadDevice

    return instance
  }

  /**
   * @param [string] options.dId
   * @param [string] options.dName
   * @param [number] options.interval
   *
   * @returns [number] device id
   */
  async add (options) {
    return this._table.add({
      id: newGuid(),
      dId: options.dId,
      dName: options.dName,
      interval: options.interval
    })
  }

  async get (id) {
    return this._table.get(id)
  }

  async update (id, options) {
    return this._table.update(id, options)
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async all () {
    return this._table.toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/upload-device.js